import { inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { TranslateLoader } from '@ngx-translate/core';
import { ILanguage } from '@shared/interfaces/language.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { ITranslationIncrementalDto } from 'src/app/translations-manager/interfaces/itranslationadmin.interface';
import { PlatformService } from './platform-service.service';

/**
 * Bootstrap blocks on the translation dictionary (see the `preloadTranslations`
 * APP_INITIALIZER), so on the server every render that misses this cache pays a
 * full round-trip to the API before it can produce any HTML. Translations change
 * rarely, so hold them far longer server-side than in the browser, where a short
 * TTL keeps an open tab reasonably fresh.
 */
const SERVER_TRANSLATION_TTL_MS = 30 * 60 * 1000;
const BROWSER_TRANSLATION_TTL_MS = 60 * 1000;

export class TranslationLoaderService implements TranslateLoader {
  AppLanguageList: Array<ILanguage> = [];

  private translations: BehaviorSubject<
    ITranslationIncrementalDto['translations']
  > = new BehaviorSubject<ITranslationIncrementalDto['translations']>([]);

  translations$ = this.translations.asObservable();

  platformService = inject(PlatformService);

  constructor(private _api: ApiService) {}

  getTranslation(
    lang: string
  ): Observable<ITranslationIncrementalDto['translations']> {
    return this._api.requestCached<ITranslationIncrementalDto['translations']>(
      ApiServiceHolder.getTranslations(lang),
      this.platformService.isServer()
        ? SERVER_TRANSLATION_TTL_MS
        : BROWSER_TRANSLATION_TTL_MS
    );

    // return this.platformService.run({
    //   browser: () => {
    //     // check local storage
    //     const translations = localStorage.getItem(`${lang}-translations`);
    //     const parsed = JSON.parse(translations);

    //     const parsedAndChecked: ITranslationIncrementalDto = {
    //       langCode: lang,
    //       lastUpdate: Number.parseInt(parsed?.lastUpdate || '0') || 0,
    //       translations: parsed?.translations || {},
    //     };
    //     const millis = parsedAndChecked.lastUpdate;

    //     this.translations.next(parsedAndChecked.translations);

    //     return this._api
    //       .request<ITranslationIncrementalDto>(
    //         ApiServiceHolder.getTranslationsAfter(lang, millis)
    //       )
    //       .pipe(
    //         map((dataR) => {
    //           const newTr = {
    //             lang: lang,
    //             lastUpdate: dataR.lastUpdate,
    //             translations: {
    //               ...parsedAndChecked.translations,
    //               ...dataR.translations,
    //             },
    //           };

    //           this.translations.next(newTr.translations);
    //           localStorage.setItem(
    //             `${lang}-translations`,
    //             JSON.stringify(newTr)
    //           );

    //           return newTr.translations;
    //         })
    //       );
    //   },
    //   server: () =>
    //     this._api.request<ITranslationIncrementalDto['translations']>(
    //       ApiServiceHolder.getTranslations(lang)
    //     ),
    // });
  }

  fillLanguages() {
    this._api
      .request<Array<ILanguage>>(ApiServiceHolder.translation.getAllLanguages())
      .subscribe((dataR) => {
        this.AppLanguageList = dataR;
      });
  }
}
